import { render, staticRenderFns } from "./messages_page.vue?vue&type=template&id=3960a76c&"
import script from "./messages_page.vue?vue&type=script&lang=js&"
export * from "./messages_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports